import { useEffect } from 'react'

import {
  addClassNamesToElement,
  mergeRegister,
  removeClassNamesFromElement
} from '@lexical/utils'
import { COMMAND_PRIORITY_EDITOR } from 'lexical'

import { useEditor } from '../../hooks/useEditor'
import { useSelectionChange } from '../../hooks/useSelectionChange'
import { $getTableNodeAtSelection } from '../../utils/table'
import {
  TABLE_COLUMN_WIDTH_CHANGE_COMMAND,
  TABLE_ROW_HEIGHT_CHANGE_COMMAND
} from '../TableCellResizerPlugin/commands'
import {
  TABLE_COLUMN_COUNT_CHANGE_COMMAND,
  TABLE_ROW_COUNT_CHANGE_COMMAND
} from '../TableContextMenuPlugin/commands'

import {
  ACTIVE_TABLE_CHANGE_COMMAND,
  TABLE_MARK_UPDATE_COMMAND,
  TABLE_SIZE_CHANGE_COMMAND
} from './commands'

export const TableControllerPlugin = () => {
  const editor = useEditor()

  // 监听激活的 table 发生变化
  useSelectionChange(() => {
    const tableNode = $getTableNodeAtSelection()
    editor.dispatchCommand(ACTIVE_TABLE_CHANGE_COMMAND, tableNode)
    return false
  })

  // 合并事件
  useEffect(() => {
    const toggleTableChange = () => {
      editor.dispatchCommand(TABLE_SIZE_CHANGE_COMMAND, undefined)
      return false
    }
    return mergeRegister(
      editor.registerCommand(
        TABLE_COLUMN_COUNT_CHANGE_COMMAND,
        toggleTableChange,
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand(
        TABLE_ROW_COUNT_CHANGE_COMMAND,
        toggleTableChange,
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand(
        TABLE_COLUMN_WIDTH_CHANGE_COMMAND,
        toggleTableChange,
        COMMAND_PRIORITY_EDITOR
      ),
      editor.registerCommand(
        TABLE_ROW_HEIGHT_CHANGE_COMMAND,
        toggleTableChange,
        COMMAND_PRIORITY_EDITOR
      )
    )
  }, [editor])

  // 设置 mark 样式
  useEffect(() => {
    return editor.registerCommand(
      TABLE_MARK_UPDATE_COMMAND,
      ({ marked, cellNodes }) => {
        for (const cellNode of cellNodes) {
          const el = editor.getElementByKey(cellNode.getKey())
          if (!el) continue
          if (marked) {
            addClassNamesToElement(el, editor._config.theme.tableCellMarked)
          } else {
            removeClassNamesFromElement(
              el,
              editor._config.theme.tableCellMarked
            )
          }
        }
        return false
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  return null
}
